"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetFilterToPreviousSnapshot = useResetFilterToPreviousSnapshot;
const React = require("react");
const react_instantsearch_1 = require("react-instantsearch");
function useResetFilterToPreviousSnapshot() {
    const { uiState } = (0, react_instantsearch_1.useInstantSearch)();
    const { setUiState } = (0, react_instantsearch_1.useInstantSearch)();
    const snapshotRef = React.useRef(null);
    React.useEffect(() => {
        snapshotRef.current = structuredClone(uiState);
    }, []);
    const updateSnapshot = () => {
        snapshotRef.current = structuredClone(uiState);
    };
    const resetToPreviousSnapshot = () => {
        if (snapshotRef.current) {
            setUiState(snapshotRef.current);
        }
    };
    return { updateSnapshot, resetToPreviousSnapshot };
}
